import { lazy } from 'react';
import AuthRoles from '@/app/auth/authRoles';

const CompanyDetailsPage = lazy(() => import('./CompanyDetailsPage'));

const CompanyDetailsConfig = {
  settings: {
    layout: {
      config: {},
    },
  },
  auth: AuthRoles.Sales,
  routes: [
    {
      path: 'companies/:id',
      element: <CompanyDetailsPage />,
    },
  ],
};

export default CompanyDetailsConfig;
